import { fromJS } from 'immutable'
import * as types from './action-types'

const InitialState = fromJS({
  active: false,
  overArtists: false,
  menu: [
    {
      id: 'artists',
      title: "Artists",
      link: "/artists"
    },
    {
      id: 'info',
      title: "Contact",
      link: "/contact"
    }
  ],
  back: [
    {
      id: 'back',
      title: "Back",
      link: ".."
    }
  ]
})

export default (state = InitialState, action) => {
    switch (action.type) {
        case types.MOUSE_ENTER_NAV:
          return state.set('active', true)
        case types.NAV_OVER_ARTISTS:
          return state.set('overArtists', true)
        case types.NAV_OUT_ARTISTS:
          return state.set('overArtists', false)
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/navigation/reducer.js